import { render, staticRenderFns } from "./IconConfiguratorCheck.vue?vue&type=template&id=caf13dcc&"
import script from "./IconConfiguratorCheck.vue?vue&type=script&lang=js&"
export * from "./IconConfiguratorCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports